import { useMemo } from 'react'

import { getAuth } from 'firebase/auth'

import { useAuth } from './use-auth'

export const usePlaybookAuth = () => {
    const { setLoginPage, setSsoLoginPage } = useAuth()

    return useMemo(
        () => ({
            onError: async (err: Error) => {
                const isAnonymous = await getAuth().currentUser?.isAnonymous

                // show login page ONLY if user is an anonymous.
                // if user IS NOT anonymous and received forbidden again
                // that means that video is restricted and we should show login.
                if (err.message === 'Forbidden') {
                    const errObj = err as unknown as { authUrl?: string }
                    const authUrl = errObj.authUrl

                    if (!!authUrl && isAnonymous) {
                        setSsoLoginPage(authUrl)
                        return
                    }

                    setLoginPage(Boolean(isAnonymous))
                }
            },
        }),
        [setLoginPage, setSsoLoginPage],
    )
}
